export function ErrorState({
  title = "Something went wrong",
  hint,
  onRetry,
}: {
  title?: string;
  hint?: string;
  onRetry?: () => void;
}) {
  return (
    <div className="empty-state">
      <div className="error-state-title">{title}</div>
      {hint && <div className="error-state-hint">{hint}</div>}
      {onRetry && (
        <button className="btn btn-sm error-state-action" onClick={onRetry}>
          Retry
        </button>
      )}
    </div>
  );
}
